/**
 * @generated SignedSource<<b65c879d176b51d56bd6adefccb3727e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

const node = {
  "kind": "InlineDataFragment",
  "name": "readingHistoryActionMenuBookmarkButtonArticle"
};
node.hash = "a7c80ae823596510ff3e2edc0684d236";
export default node;